import { Component } from '@angular/core';

@Component({
  selector: 'app-order-details-skeleton',
  templateUrl: './order-details-skeleton.component.html',
  styleUrls: ['./order-details-skeleton.component.scss']
})
export class OrderDetailsSkeletonComponent {}
